.atm_vy_1osqo2v{width:100%;}
.atm_gi_idpfg4{margin:0;}
.atm_e2_1osqo2v{height:100%;}
.atm_9j_73adwj{cursor:default;}
.atm_k4_idpfg4{opacity:0;}
.atm_mk_stnw88{position:absolute;}
.atm_tk_idpfg4{top:0;}
.atm_fq_idpfg4{left:0;}
